module.exports = __webpack_public_path__ + "img/reward-give-icon-zh.7666e71f.png";